export default __webpack_public_path__ + "static/media/NDL_36.529d30a4.png";